import { Typography } from "@mui/material";

import { usePreviewCourse } from "../../hooks/usePreviewCourse";

export function CourseRecommendedPace() {
	const { course } = usePreviewCourse();

	const getFrequencyText = () => {
		if (!course) {
			return "";
		}

		let classesPerDay = "";
		let frequency = "";
		if (course.classesPerDay === 1) {
			classesPerDay = "1 Class";
		} else {
			classesPerDay = `${course.classesPerDay} Classes`;
		}

		if (course.frequency === "D") {
			frequency = "day";
		} else if (course.frequency === "W") {
			frequency = "week";
		}

		return `${classesPerDay} every ${frequency} until completion`;
	};

	const getEstimateText = () => {
		if (!course) {
			return "";
		}

		const numberOfDay = Math.ceil(course.lesson.length / course.classesPerDay);

		let frequency = "";
		if (course.frequency === "D") {
			if (numberOfDay === 1) {
				frequency = "day";
			} else {
				frequency = "days";
			}
		} else if (course.frequency === "W") {
			if (numberOfDay === 1) {
				frequency = "week";
			} else {
				frequency = "weeks";
			}
		}

		return `*Following recommended pace, it will take you about ${numberOfDay} ${frequency} to complete this course assuming no disruptions.`;
	};

	if (!course) {
		return null;
	}

	return (
		<div className="course-recommended-pace-container">
			<Typography className="big-text black-label">Recommended Pace</Typography>
			<Typography className="normal-text">{getFrequencyText()}</Typography>
			<Typography className="normal-text">{getEstimateText()}</Typography>
		</div>
	);
}
